import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modal-cal-form2',
  templateUrl: './modal-cal-form2.component.html',
  styleUrls: ['./modal-cal-form2.component.scss']
})
export class ModalCalForm2Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
